import {DraggableObject} from '../../../../base/DraggableObject';
import {Graphics, Sprite, Text} from 'pixi.js';
import {TextFactory} from '../../../../factories/TextFactory';
import {StaticData} from '../../../../data/StaticData';
import {DrawColor} from '../../draw_menu/instument_top_block/color_picker/DrawColor';
import {Pivot} from '../../../../utils/Pivot';
import {IPoint} from '../../../../interfaces/primitives/IPoint';

export class TextCursor extends DraggableObject
{
    private cursorGraphics: Graphics;
    private textField: Text;
    private _drawColor: DrawColor = DrawColor.BLACK;
    private _size: number = 0;
    private fontSize: number = 0;
    private colorInterval: number | undefined;
    private colorWhite: boolean = false;

    constructor(private card: Sprite) {
        super();
        this.cursorGraphics = new Graphics();
        this.textField = TextFactory.create('');
        this.addChild(this.cursorGraphics);
        this.addChild(this.textField);

        this.textField.interactive = false;
    }

    startBlink() {
        this.stopBlink();
        this.colorInterval = window.setInterval(this.toggleColor.bind(this), 500);
    }

    stopBlink() {
        window.clearInterval(this.colorInterval);
    }

    toggleColor() {
        this.colorWhite = !this.colorWhite;
        this.updateCursor();
    }

    setSize(value: number) {
        this._size = value;
        this.fontSize = StaticData.drawCursorMinimalSize + (StaticData.drawCursorMaximalSize - StaticData.drawCursorMinimalSize) * this._size + 20;
        this.textField.style.fontSize = this.fontSize;
        this.updateInputTextPivot();
        this.updateCursor();
    }

    setDrawColor(value: DrawColor) {
        this._drawColor = value;
        this.textField.style.fill = this._drawColor;
        this.updateCursor();
    }

    removeLastChar() {
        let lastDeleted: string[] = this.textField.text.split('');
        lastDeleted.pop();
        this.textField.text = lastDeleted.join('');
        this.updateInputTextPivot();
        this.updateCursor();
    }

    addChar(key: string) {
        if (this.cursorGraphics.width > this.card.width) {
            return;
        }
        this.textField.text += key;
        this.updateInputTextPivot();
        this.updateCursor();
    }

    updateCursor(): void {
        this.updateCursorWidth(this.textField.width);
    }

    /**
     * Ограничение перемещения внутри области перетаскивания
     * @param x - желаемая координата по горизонтали
     * @param y - желаемая координата по вертикали
     * @returns объект содержащий возможные координаты, полученные из желаемых
     */
    clampPos(x: number, y: number): IPoint {
        let deltaX: number = (this.cursorGraphics.width - this.card.width) / 2;
        let deltaY: number = (this.cursorGraphics.height - this.card.height) / 2;
        x = Math.max(Math.min(x, -deltaX), deltaX);
        y = Math.min(Math.max(y, deltaY), -deltaY);
        if (this.cursorGraphics.width > this.card.width) {
            x = 0;
        }
        return {x, y};
    }

    setBorderVisible(value: boolean = true) {
        this.cursorGraphics.visible = value;
    }

    clear(): void {
        this.textField.text = '';
        this.updateCursor();
    }

    updateClamp(): void {
        this.moveTo(this.clampPos(this.x, this.y));
    }

    private updateInputTextPivot() {
        Pivot.centerPivot(this.textField);
    }

    private updateCursorWidth(width: number) {
        this.cursorGraphics.clear();
        this.cursorGraphics.lineStyle(1, this.colorWhite ? 0xffffff : this._drawColor);
        this.cursorGraphics.beginFill(0, .0001);
        this.cursorGraphics.drawRect(-this.fontSize / 8 - width / 2, -this.fontSize / 2, this.fontSize / 4 + width, this.fontSize);
        this.cursorGraphics.endFill();
        this.cursorGraphics.interactive = true;
        this.updateClamp();
    }
}
